import React from 'react'
import styles from '../../EdofSection/LightPerformance/LightPerformance.module.css'

const LightPerformance = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.carLight}>
                <img src='Images/carLight.webp' alt=' Man driving with with and teen daughter at night' loading="lazy" decoding="async" />
            </div>
            <div className={styles.LowLightDiv}>
                <div className={styles.LowLightIcon}>
                    <img src='Images/Low-Light-Icon.webp' alt='icon of Deseyne® superior low light performance' loading="lazy" decoding="async" />
                </div>
                <div className={styles.LowLighttContent}>
                    <h1 className={styles.title}>Low Light Performance</h1>
                    {/* <h3 className={styles.subtitle}>XXX</h3> */}
                    <div className={styles.description}>
                        <p >Deseyne EDOF delivers a stable, high-contrast image with crisp
                            edges in any lighting condition. By directing over 90% of incoming light to the object of focus, it
                            preserves sharp contrast even in low‑light conditions, regardless of pupil size.</p>
                    </div>
                </div>

            </div>
            <div className={styles.PracticeDiv}>
                <div>
                    <img src='Images/Patients-Practice.webp' alt=' middle age man on grass comfortably reading a book' loading="lazy" decoding="async" />

                </div>

                <div className={styles.PracticeContent}>
                    <h1 className={styles.title}>Benefits For Patients and Practice</h1>
                    {/* <h3 className={styles.subtitle}>XXX</h3> */}
                    <div className={styles.description}>
                        <p>Deseyne® soft contact lenses demonstrated clinically meaningful improvements across multiple visual performance metrics, including distance-corrected depth of focus, intermediate acuity, near acuity, and mesopic contrast sensitivity, compared with the control lens.</p>
                        <p>Deseyne® for Presbyopia with Extended Depth of Focus (EDOF) supports patient
                            satisfaction by delivering strong visual performance, hydration, and comfort, while helping
                            reduce common presbyopia-related challenges such as extended chair time and multiple refits.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LightPerformance
